<template>
  <div class="fund-card-wrapper">
    <blank-card :width="width" :max-width="maxWidth">
      <div class="fund-card-inner-wrapper">
        <h2 class="header">{{header}}</h2>
        <div v-if="subHeader" class="sub-header">{{subHeader}}</div>
        <div>
          <a
            data-action="open_fund"
            data-listname="stock_quote"
            :data-fundname="elem.thailand_fund_code"
            v-for="(elem,index) in computedFundList"
            :key="index"
            :href="'/miniapp/fund/overview?id='+elem.mstar_id"
          >
            <border-btn :text="elem.thailand_fund_code" />
          </a>
          <div v-if="showSeeMore" class="cursor-pointer other-fund" @click="unhideLengthyFundFn()">
            ดูทั้งหมด
            <i class="fa fa-angle-down" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </blank-card>
  </div>
</template>

<script>
import BlankCard from "../../commons/BlankCard";
import BorderBtn from "../../commons/BorderBtn";

export default {
  name: "fund-card",
  components: {
    BlankCard,
    BorderBtn
  },
  props: {
    // Props to receive
    // width ( type: Number, required: false, description: 'Width as a percentage of parent component')
    // max-width ( type:Number, required: false, description: 'Max width of the card')
    // header ( type:String, required: false, description: 'Header of the card')
    // subHeader ( type:String, required: false, description: 'Sub header of the card')
    // hideLengthyFund ( type:Boolean require:false, description: 'Boolean that check if fund longer than numOfStartFund should be hide')
    // numOfStartFund ( type:Number, require:false, description: 'Number of cut point for lenthy fund list')
    // unhideLengthyFundFn ( type:Function, require:false, desctipion: 'Function that will be invoked when user click see more')

    width: {
      type: Number,
      default: 100
    },
    maxWidth: {
      type: Number,
      default: 967
    },
    header: {
      type: String,
      default: ""
    },
    subHeader: {
      type: String,
      default: ""
    },
    fundLink: {
      type: String,
      default: "/fund/"
    },
    fundList: {
      type: Array,
      default: () => []
    },
    hideLengthyFund: {
      type: Boolean,
      default: true
    },
    numOfStartFund: {
      type: Number,
      default: 10
    },
    unhideLengthyFundFn: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    showSeeMore() {
      return (
        this.hideLengthyFund & (this.fundList.length > this.numOfStartFund)
      );
    },
    numOtherFund() {
      return this.fundList.length - this.numOfStartFund;
    },
    computedFundList() {
      if (this.hideLengthyFund) {
        return this.fundList.slice(0, this.numOfStartFund);
      }
      return this.fundList;
    }
  }
};
</script>

<style lang='scss' scoped>
.fund-card-wrapper {
  padding: 15px;
  .fund-card-inner-wrapper {
    padding-bottom: 25px;
    .header {
      font-size: 23px;
      font-weight: bold;
      display: inline-block;
      color: $black;
      margin-bottom: 0px;
    }
    .sub-header {
      margin-top: 6px;
      margin-bottom: 20px;
      font-size: 15px;
      color: $finno-orange;
    }
  }

  .other-fund {
    color: $finno-orange;
    display: inline-block;
    margin-top: 5px;
    font-weight: bold;
    @extend %font-size-ss;
    border-bottom: 1px solid $finno-orange;
  }

  @media screen and (max-width: 420px) {
    .fund-card-inner-wrapper {
      .header {
        font-size: 17px;
      }
    }
  }
}
</style>
